// Country utilities for international payment support

export const COUNTRIES = [
  // United States first as default
  { code: 'US', name: 'United States', requiresState: true, postalFormat: 'ZIP Code', postalPattern: /^\d{5}(-\d{4})?$/, postalPlaceholder: '12345 or 12345-6789' },
  // All other countries alphabetically
  { code: 'AR', name: 'Argentina', requiresState: false, postalFormat: 'Postal Code', postalPattern: /^[A-Z]\d{4}[A-Z]{3}$/i, postalPlaceholder: 'C1234ABC' },
  { code: 'AU', name: 'Australia', requiresState: true, postalFormat: 'Postcode', postalPattern: /^\d{4}$/, postalPlaceholder: '2000' },
  { code: 'AT', name: 'Austria', requiresState: false, postalFormat: 'Postal Code', postalPattern: /^\d{4}$/, postalPlaceholder: '1010' },
  { code: 'BE', name: 'Belgium', requiresState: false, postalFormat: 'Postal Code', postalPattern: /^\d{4}$/, postalPlaceholder: '1000' },
  { code: 'BM', name: 'Bermuda', requiresState: false, postalFormat: 'Postal Code', postalPattern: /^[A-Z]{2} [A-Z0-9]{2}$/i, postalPlaceholder: 'HM 12' },
  { code: 'BO', name: 'Bolivia', requiresState: false, postalFormat: 'Postal Code', postalPattern: /^\d{4}$/, postalPlaceholder: '1234' },
  { code: 'BR', name: 'Brazil', requiresState: true, postalFormat: 'CEP', postalPattern: /^\d{5}-\d{3}$/, postalPlaceholder: '12345-678' },
  { code: 'BG', name: 'Bulgaria', requiresState: false, postalFormat: 'Postal Code', postalPattern: /^\d{4}$/, postalPlaceholder: '1234' },
  { code: 'CA', name: 'Canada', requiresState: true, postalFormat: 'Postal Code', postalPattern: /^[A-Z]\d[A-Z] \d[A-Z]\d$/i, postalPlaceholder: 'A1A 1A1' },
  { code: 'CL', name: 'Chile', requiresState: false, postalFormat: 'Postal Code', postalPattern: /^\d{7}$/, postalPlaceholder: '1234567' },
  { code: 'CN', name: 'China', requiresState: true, postalFormat: 'Postal Code', postalPattern: /^\d{6}$/, postalPlaceholder: '123456' },
  { code: 'CO', name: 'Colombia', requiresState: false, postalFormat: 'Postal Code', postalPattern: /^\d{6}$/, postalPlaceholder: '123456' },
  { code: 'HR', name: 'Croatia', requiresState: false, postalFormat: 'Postal Code', postalPattern: /^\d{5}$/, postalPlaceholder: '12345' },
  { code: 'CY', name: 'Cyprus', requiresState: false, postalFormat: 'Postal Code', postalPattern: /^\d{4}$/, postalPlaceholder: '1234' },
  { code: 'CZ', name: 'Czech Republic', requiresState: false, postalFormat: 'Postal Code', postalPattern: /^\d{3} \d{2}$/, postalPlaceholder: '123 45' },
  { code: 'DK', name: 'Denmark', requiresState: false, postalFormat: 'Postal Code', postalPattern: /^\d{4}$/, postalPlaceholder: '1000' },
  { code: 'EC', name: 'Ecuador', requiresState: false, postalFormat: 'Postal Code', postalPattern: /^\d{6}$/, postalPlaceholder: '123456' },
  { code: 'EG', name: 'Egypt', requiresState: false, postalFormat: 'Postal Code', postalPattern: /^\d{5}$/, postalPlaceholder: '12345' },
  { code: 'EE', name: 'Estonia', requiresState: false, postalFormat: 'Postal Code', postalPattern: /^\d{5}$/, postalPlaceholder: '12345' },
  { code: 'FI', name: 'Finland', requiresState: false, postalFormat: 'Postal Code', postalPattern: /^\d{5}$/, postalPlaceholder: '00100' },
  { code: 'FR', name: 'France', requiresState: false, postalFormat: 'Postal Code', postalPattern: /^\d{5}$/, postalPlaceholder: '75001' },
  { code: 'GF', name: 'French Guiana', requiresState: false, postalFormat: 'Postal Code', postalPattern: /^\d{5}$/, postalPlaceholder: '97300' },
  { code: 'DE', name: 'Germany', requiresState: false, postalFormat: 'Postal Code', postalPattern: /^\d{5}$/, postalPlaceholder: '12345' },
  { code: 'GR', name: 'Greece', requiresState: false, postalFormat: 'Postal Code', postalPattern: /^\d{3} \d{2}$/, postalPlaceholder: '123 45' },
  { code: 'GY', name: 'Guyana', requiresState: false, postalFormat: 'Postal Code', postalPattern: /^.*$/, postalPlaceholder: 'Optional' },
  { code: 'HK', name: 'Hong Kong', requiresState: false, postalFormat: 'Postal Code', postalPattern: /^.*$/, postalPlaceholder: 'Optional' },
  { code: 'HU', name: 'Hungary', requiresState: false, postalFormat: 'Postal Code', postalPattern: /^\d{4}$/, postalPlaceholder: '1234' },
  { code: 'IS', name: 'Iceland', requiresState: false, postalFormat: 'Postal Code', postalPattern: /^\d{3}$/, postalPlaceholder: '123' },
  { code: 'IN', name: 'India', requiresState: true, postalFormat: 'PIN Code', postalPattern: /^\d{6}$/, postalPlaceholder: '123456' },
  { code: 'IE', name: 'Ireland', requiresState: false, postalFormat: 'Eircode', postalPattern: /^[A-Z]\d{2} [A-Z0-9]{4}$/i, postalPlaceholder: 'D02 XY45' },
  { code: 'IL', name: 'Israel', requiresState: false, postalFormat: 'Postal Code', postalPattern: /^\d{5,7}$/, postalPlaceholder: '1234567' },
  { code: 'IT', name: 'Italy', requiresState: false, postalFormat: 'Postal Code', postalPattern: /^\d{5}$/, postalPlaceholder: '00100' },
  { code: 'JP', name: 'Japan', requiresState: false, postalFormat: 'Postal Code', postalPattern: /^\d{3}-\d{4}$/, postalPlaceholder: '100-0001' },
  { code: 'LV', name: 'Latvia', requiresState: false, postalFormat: 'Postal Code', postalPattern: /^LV-\d{4}$/i, postalPlaceholder: 'LV-1234' },
  { code: 'LT', name: 'Lithuania', requiresState: false, postalFormat: 'Postal Code', postalPattern: /^LT-\d{5}$/i, postalPlaceholder: 'LT-12345' },
  { code: 'LU', name: 'Luxembourg', requiresState: false, postalFormat: 'Postal Code', postalPattern: /^L-\d{4}$/i, postalPlaceholder: 'L-1234' },
  { code: 'MT', name: 'Malta', requiresState: false, postalFormat: 'Postal Code', postalPattern: /^[A-Z]{3} \d{4}$/i, postalPlaceholder: 'ABC 1234' },
  { code: 'MX', name: 'Mexico', requiresState: true, postalFormat: 'Postal Code', postalPattern: /^\d{5}$/, postalPlaceholder: '12345' },
  { code: 'NL', name: 'Netherlands', requiresState: false, postalFormat: 'Postal Code', postalPattern: /^\d{4} [A-Z]{2}$/i, postalPlaceholder: '1012 AB' },
  { code: 'NZ', name: 'New Zealand', requiresState: false, postalFormat: 'Postcode', postalPattern: /^\d{4}$/, postalPlaceholder: '1010' },
  { code: 'NO', name: 'Norway', requiresState: false, postalFormat: 'Postal Code', postalPattern: /^\d{4}$/, postalPlaceholder: '0001' },
  { code: 'PA', name: 'Panama', requiresState: false, postalFormat: 'Postal Code', postalPattern: /^\d{4}$/, postalPlaceholder: '1234' },
  { code: 'PY', name: 'Paraguay', requiresState: false, postalFormat: 'Postal Code', postalPattern: /^\d{4}$/, postalPlaceholder: '1234' },
  { code: 'PE', name: 'Peru', requiresState: false, postalFormat: 'Postal Code', postalPattern: /^\d{5}$/, postalPlaceholder: '12345' },
  { code: 'PL', name: 'Poland', requiresState: false, postalFormat: 'Postal Code', postalPattern: /^\d{2}-\d{3}$/, postalPlaceholder: '12-345' },
  { code: 'PT', name: 'Portugal', requiresState: false, postalFormat: 'Postal Code', postalPattern: /^\d{4}-\d{3}$/, postalPlaceholder: '1234-567' },
  { code: 'RO', name: 'Romania', requiresState: false, postalFormat: 'Postal Code', postalPattern: /^\d{6}$/, postalPlaceholder: '123456' },
  { code: 'RU', name: 'Russia', requiresState: false, postalFormat: 'Postal Code', postalPattern: /^\d{6}$/, postalPlaceholder: '123456' },
  { code: 'SA', name: 'Saudi Arabia', requiresState: false, postalFormat: 'Postal Code', postalPattern: /^\d{5}$/, postalPlaceholder: '12345' },
  { code: 'SG', name: 'Singapore', requiresState: false, postalFormat: 'Postal Code', postalPattern: /^\d{6}$/, postalPlaceholder: '123456' },
  { code: 'SK', name: 'Slovakia', requiresState: false, postalFormat: 'Postal Code', postalPattern: /^\d{3} \d{2}$/, postalPlaceholder: '123 45' },
  { code: 'SI', name: 'Slovenia', requiresState: false, postalFormat: 'Postal Code', postalPattern: /^\d{4}$/, postalPlaceholder: '1234' },
  { code: 'ZA', name: 'South Africa', requiresState: false, postalFormat: 'Postal Code', postalPattern: /^\d{4}$/, postalPlaceholder: '1234' },
  { code: 'KR', name: 'South Korea', requiresState: false, postalFormat: 'Postal Code', postalPattern: /^\d{5}$/, postalPlaceholder: '12345' },
  { code: 'ES', name: 'Spain', requiresState: false, postalFormat: 'Postal Code', postalPattern: /^\d{5}$/, postalPlaceholder: '28001' },
  { code: 'SR', name: 'Suriname', requiresState: false, postalFormat: 'Postal Code', postalPattern: /^.*$/, postalPlaceholder: 'Optional' },
  { code: 'SE', name: 'Sweden', requiresState: false, postalFormat: 'Postal Code', postalPattern: /^\d{3} \d{2}$/, postalPlaceholder: '123 45' },
  { code: 'CH', name: 'Switzerland', requiresState: false, postalFormat: 'Postal Code', postalPattern: /^\d{4}$/, postalPlaceholder: '8001' },
  { code: 'TR', name: 'Turkey', requiresState: false, postalFormat: 'Postal Code', postalPattern: /^\d{5}$/, postalPlaceholder: '12345' },
  { code: 'AE', name: 'United Arab Emirates', requiresState: false, postalFormat: 'Postal Code', postalPattern: /^.*$/, postalPlaceholder: 'Optional' },
  { code: 'GB', name: 'United Kingdom', requiresState: false, postalFormat: 'Postcode', postalPattern: /^[A-Z]{1,2}\d[A-Z\d]? \d[A-Z]{2}$/i, postalPlaceholder: 'SW1A 1AA' },
  { code: 'UY', name: 'Uruguay', requiresState: false, postalFormat: 'Postal Code', postalPattern: /^\d{5}$/, postalPlaceholder: '12345' },
  { code: 'VE', name: 'Venezuela', requiresState: false, postalFormat: 'Postal Code', postalPattern: /^\d{4}$/, postalPlaceholder: '1234' }
];

export const getCountryInfo = (countryCode) => {
  return COUNTRIES.find(c => c.code === countryCode) || COUNTRIES[0]; // Default to US
};

export const getPostalLabel = (countryCode) => {
  const country = getCountryInfo(countryCode);
  return country.postalFormat;
};

export const getPostalPlaceholder = (countryCode) => {
  const country = getCountryInfo(countryCode);
  return country.postalPlaceholder;
};

export const getPostalPattern = (countryCode) => {
  const country = getCountryInfo(countryCode);
  return country.postalPattern;
};

export const getStateLabel = (countryCode) => {
  switch (countryCode) {
    case 'US':
      return 'State';
    case 'CA':
      return 'Province';
    case 'AU':
      return 'State/Territory';
    case 'BR':
      return 'State';
    case 'MX':
      return 'State';
    case 'IN':
      return 'State';
    case 'CN':
      return 'Province';
    default:
      return 'State/Province/Region';
  }
};

export const isStateRequired = (countryCode) => {
  const country = getCountryInfo(countryCode);
  return country.requiresState;
};

export const validatePostalCode = (postalCode, countryCode) => {
  if (!postalCode) return false;
  const pattern = getPostalPattern(countryCode);
  return pattern.test(postalCode.trim());
};

export const formatPostalCode = (postalCode, countryCode) => {
  if (!postalCode) return '';
  
  const cleaned = postalCode.replace(/\s+/g, '').toUpperCase();
  
  switch (countryCode) {
    case 'CA':
      // Format Canadian postal codes: A1A1A1 -> A1A 1A1
      if (cleaned.length === 6) {
        return `${cleaned.slice(0, 3)} ${cleaned.slice(3)}`;
      }
      break;
    case 'GB':
      // Format UK postcodes: basic spacing
      if (cleaned.length >= 5) {
        const lastThree = cleaned.slice(-3);
        const firstPart = cleaned.slice(0, -3);
        return `${firstPart} ${lastThree}`;
      }
      break;
    case 'NL':
      // Format Dutch postal codes: 1234AB -> 1234 AB
      if (cleaned.length === 6) {
        return `${cleaned.slice(0, 4)} ${cleaned.slice(4)}`;
      }
      break;
    case 'SE':
    case 'CZ':
    case 'SK':
    case 'GR':
      // Format with space: 12345 -> 123 45
      if (cleaned.length === 5) {
        return `${cleaned.slice(0, 3)} ${cleaned.slice(3)}`;
      }
      break;
    case 'PL':
      // Format Polish postal codes: 12345 -> 12-345
      if (cleaned.length === 5) {
        return `${cleaned.slice(0, 2)}-${cleaned.slice(2)}`;
      }
      break;
    case 'PT':
      // Format Portuguese postal codes: 1234567 -> 1234-567
      if (cleaned.length === 7) {
        return `${cleaned.slice(0, 4)}-${cleaned.slice(4)}`;
      }
      break;
    case 'BR':
      // Format Brazilian CEP: 12345678 -> 12345-678
      if (cleaned.length === 8) {
        return `${cleaned.slice(0, 5)}-${cleaned.slice(5)}`;
      }
      break;
    case 'JP':
      // Format Japanese postal codes: 1234567 -> 123-4567
      if (cleaned.length === 7) {
        return `${cleaned.slice(0, 3)}-${cleaned.slice(3)}`;
      }
      break;
  }
  
  return postalCode; // Return original if no formatting needed
};
